import React, { useEffect, useState, useRef } from 'react'
import resumeCss from './Resume.module.css'
import ResumePricing from '../Pricing/ResumePricing';
import axios from 'axios';
import { setFetching, setResume, setProfileImg, setUser, setIsResumeSubbed, setResumeSubDuration } from "../../redux/states";
import { useErrorSetter, useSuccessSetter } from '../../hooks/useUiMessages';
import { checkAuthenticatedUser } from '../../utils/client-functions';
import Alert from '@mui/material/Alert';
import { pdf, PDFViewer, StyleSheet, Text, Document, Page } from '@react-pdf/renderer';
import { saveAs } from 'file-saver';
import ProtectedContent from "../UI/ProtectedContent/ProtectedContent ";
import { useConfirm } from "material-ui-confirm";
import avatarImg from '../../images/avatar.png'
import { useNavigate } from 'react-router-dom'
import { useSelector, useDispatch } from "react-redux";
import { ButtonSubmitGreen, ButtonOutlineGreenWithDiffStyle } from '../UI/Buttons/Buttons';
import DownloadForOfflineIcon from '@mui/icons-material/DownloadForOffline';
import { PiPlugsConnected } from "react-icons/pi";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import carouselData from './carousel-items';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import AuthSideMenu from '../UI/AuthSideMenu/AuthSideMenu';
import AuthHeader from '../UI/AuthHeader/AuthHeader';
import StandardPDF from './Templates/Standard/StandardPDF'
import EuroPass from './Templates/Europass/EuroPass';
import Auckland from './Templates/Auckland/Auckland';
import BubbleFish from './Templates/BubbleFish/BubbleFish';
import {jwtDecode} from 'jwt-decode';

import holisticAnalytics from '../../utils/holisticAnalytics';
import { useTheme } from "../UI/Theme/ThemeContext";
import { DataContainerStyled, PageDataContainerStyled } from "../../styled/Resume";
import DataHeader from "./DataHeader";
import InputHandler from "./Tools/InputHandler";
import BubbleFloat from "../UI/BubbleFloat/BubbleFloat";
const screenWidth = window.innerWidth



const CarouselItem = ({ item, index, activeIndex, handleItemClick }) => {
    return (
        <div
            className={resumeCss.carouselInner}
            key={index}
            onClick={() => handleItemClick(index)}
        >
            <h5>{item.title}</h5>
            <div className={`${activeIndex === index ? resumeCss.carouselMiddleActive : resumeCss.carouselMiddle}`} style={{backgroundImage: `url(${item.image})` }}>
                {activeIndex === index && <CheckCircleIcon fontSize='inherit' />}
            </div>
        </div>
    );
};

const styles = StyleSheet.create({
    viewerContainer: {
        width: '100%',
        height: screenWidth > 800 ? 1000 : 700
    },
    StandardContainer: {
        display: "block",
        padding: 20,
        lineHeight: 1.2,
        fontSize: 20,
        fontWeight: '900',
        paddingTop: 50
    },
});


const DownloadResume = () => {
    const { resume, resumeSubDuration, user, userResumesAll, resumeServicesNumbers, profileImg } = useSelector(state => state.stateData)
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { themeName } = useTheme();
    const confirm = useConfirm();
    const componentRef = useRef();
    const [authMenuOpen, setAuthMenuOpen] = useState(false)
    const [hasDownloadedCv, setHasDownloadedCv] = useState(false)
    const [canPrint, setCanPrint] = useState(false)
    const [activeIndex, setActiveIndex] = useState(null);
    const [carouselName, setCarouselName] = useState("");
    const [imgUrl, setImgUrl] = useState(
        (resume?.storageDetails?.imgUrl) || profileImg || avatarImg
    );
    const [hasImg, setHasImg] = useState(false);
    const [resumeNameExist, setResumeNameExist] = useState(false);
    const [isSubscribed, setIsSubscribed] = useState(true);
    const [storageDetails, setStorageDetails] = useState({
        name: "",
        desc: "",
        imgUrl:"",
        template: "Standard",
        resumeLink: "",
        buildDate: ""
    })
    const isAuth = localStorage?.getItem('token')
    const authUser = isAuth && jwtDecode(isAuth)
    const hasDroppedFeedback = authUser && authUser.rated

    const errorSetter = useErrorSetter();
    const successSetter = useSuccessSetter();

    const [pricingOpen, setPricingOpen] = useState(false);

    useEffect(() => {
        const handler = () => setPricingOpen(true);
        window.addEventListener('openResumePricing', handler);
        return () => window.removeEventListener('openResumePricing', handler);
    }, []);

    useEffect(() => {
        const handleContextMenu = (event) => {
            event.preventDefault(); // Prevent the default right-click context menu
        };

        document.addEventListener('contextmenu', handleContextMenu);

        // Cleanup the event listener on component unmount
        return () => {
            document.removeEventListener('contextmenu', handleContextMenu);
        };
    }, []);

    useEffect(() => {
        const checkIfAuthUser = async () => {
            try {
                await checkAuthenticatedUser();
            } catch (error) {
                localStorage?.removeItem("token");
                navigate("/popin?resume");
            }
        };
        checkIfAuthUser();

    }, [navigate])

    // Fetch fresh subscription data on mount so this page is self-sufficient
    // regardless of navigation path. Home.js overwrites Redux user without
    // resumeSubscriptions, which causes false "Please SUBSCRIBE" errors.
    useEffect(() => {
        if (!isAuth) return;
        let cancelled = false;
        (async () => {
            try {
                const response = await axios.get('/user/resume', {
                    headers: { 'x-access-token': isAuth }
                });
                if (cancelled || response?.data?.status === 'unauthenticated') return;
                const userData = response?.data?.user;
                if (!userData) return;
                dispatch(setUser(userData));
                const { resumeSubscriptions } = userData;
                if (resumeSubscriptions) {
                    dispatch(setIsResumeSubbed(!!resumeSubscriptions.subscribed));
                    dispatch(setResumeSubDuration(resumeSubscriptions.duration || ""));
                }
            } catch (_) {
                // Silent fail — stale Redux state remains as fallback
            }
        })();
        return () => { cancelled = true; };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        const resumeLength = Object.keys(resume).length;
        const userLength = Object.keys(user).length;

        if (resumeLength < 1 || userLength < 1 ) {
            navigate('/user/dashboard/resume?customize');
        } 
    }, [user, resume, navigate]);
    
    
    //scroll to page top on render
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    // When an image-based template is selected, ensure we default to the user's profile image.
    // If profileImg isn't in Redux yet, silently fetch it and set locally (no loading UI).
    useEffect(() => {
        // Only run when a template requiring an image is active
        if (!hasImg) return;

        // If an explicit resume image was already set or user uploaded one, don't override
        if (resume?.storageDetails?.imgUrl || storageDetails?.imgUrl) return;

        // If profile image in Redux, use it
        if (profileImg) {
            if (imgUrl !== profileImg) setImgUrl(profileImg);
            if (!storageDetails?.imgUrl) setStorageDetails(prev => ({ ...prev, imgUrl: profileImg }));
            return;
        }

        // Silent fetch to get profile image if not available yet
        const token = localStorage?.getItem('token');
        if (!token) return;
        let cancelled = false;
        (async () => {
            try {
                const resp = await axios.get('/dashboard/get-profile', {
                    headers: { 'x-access-token': token }
                });
                const fetched = resp?.data?.profile?.profileImg;
                if (!cancelled && fetched) {
                    setImgUrl(fetched);
                    if (!storageDetails?.imgUrl) setStorageDetails(prev => ({ ...prev, imgUrl: fetched }));
                    // cache in Redux for future usage
                    dispatch(setProfileImg(fetched));
                }
            } catch (_) {
                // Silent fail, keep default avatar
            }
        })();

        return () => { cancelled = true; };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [hasImg]);

    // If profileImg later becomes available in Redux while on an image template, adopt it
    useEffect(() => {
        if (!hasImg) return;
        if (resume?.storageDetails?.imgUrl || storageDetails?.imgUrl) return;
        if (profileImg && imgUrl !== profileImg) {
            setImgUrl(profileImg);
            setStorageDetails(prev => ({ ...prev, imgUrl: profileImg }));
        }
    }, [profileImg, hasImg, imgUrl, resume?.storageDetails?.imgUrl, storageDetails?.imgUrl]);

    //Option for carousel in template section
    const responsive = {
      desktop: {
        breakpoint: { max: 3000, min: 1024 },
        items: 6,
        slidesToSlide: 3 // optional, default to 1.
      },
      tablet: {
        breakpoint: { max: 1024, min: 700 },
        items: 3,
        slidesToSlide: 2 // optional, default to 1.
      },
      mobile: {
        breakpoint: { max: 700, min: 0 },
        items: 1,
        slidesToSlide: 1 // optional, default to 1.
      }
    };


    const checkObjectForKeyValue = (arr, key, keyOfKey, searchValue) => {
        if (arr.some(obj => obj[key][keyOfKey] === searchValue)) {
            errorSetter("Resume name already exists")
            setResumeNameExist(true)
        } else {
            setResumeNameExist(false)
        }
    }


    const selectTemplate = () => {

        let template;
   
        switch (carouselName) {
            case "Standard":
                template  = <StandardPDF resume={resume} />
                break;
            case "Euro Pass":
                template  = <EuroPass resume={resume} imgUrl={imgUrl} />
                break;
            case "Auckland":
                template  = <Auckland resume={resume} imgUrl={imgUrl} />
                break;
            case "Bubble Fish":
                template  = <BubbleFish resume={resume} />
                break;
            case "Water Train":
            case "Sinking Duck":
                template  = (<Document>
                                <Page style={styles.StandardContainer}>
                                    <Text style={{textAlign: "left"}}>Template coming soon</Text>
                                </Page>
                            </Document>)
                break;
        
            default:
                template  = (<Document>
                                <Page style={styles.StandardContainer}>
                                    <Text style={{textAlign: "left"}}>Pick a template to display here</Text>
                                </Page>
                            </Document>)
                break;
        }

        return template
    }

    const toggleResumes = () => {
        setAuthMenuOpen(!authMenuOpen)
    }

    const handleInputChange = (prop) => (event) => {
        // console.log(storageDetails);
        setStorageDetails({ ...storageDetails, [prop]: event.target.value });
    };

    const handleItemClick = (index) => {
        const selectedCarousel = carouselData[index];
        setActiveIndex(index);
        setCarouselName(selectedCarousel.title)
    
        let canPrintFlag = false;
        if (selectedCarousel.title === "Euro Pass" || selectedCarousel.title === "Auckland" || selectedCarousel.title === "Water Train") {
            setHasImg(true)
        } else {
            setHasImg(false)
        }
    
        switch (selectedCarousel.title) {
            case "Standard":
                canPrintFlag = true;
                setStorageDetails({ ...storageDetails, template: "Standard" });
                break;
            case "Euro Pass":
                setStorageDetails({ ...storageDetails, template: "Euro Pass" });
                canPrintFlag = true;
                break;
            case "Auckland":
                setStorageDetails({ ...storageDetails, template: "Auckland" });
                canPrintFlag = true;
                break;
            case "Bubble Fish":
                setStorageDetails({ ...storageDetails, template: "Bubble Fish" });
                canPrintFlag = true;
                break;
            case "Water Train":
                setStorageDetails({ ...storageDetails, template: "Water Train" });
                canPrintFlag = false;
                break;
            default:
                canPrintFlag = false;
                break;
        }
    
        setCanPrint(canPrintFlag);
    };


    const saveImageToFolder = (blob, event) => {
        event.preventDefault();
        setFetching(true)
        const formData = new FormData();
        formData.append('file', blob);
        
        axios.post('/user/upload-img', formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
                'x-access-token': isAuth
            }
        })
        .then(response => {
            const imageUrl = response.data.url
            const secureImageUrl = imageUrl.slice(0, 4) + 's' + imageUrl.slice(4);
            setImgUrl(secureImageUrl)
            setStorageDetails({ ...storageDetails, imgUrl: secureImageUrl });
            setFetching(false)
            successSetter(`Image uploaded successfully!`);
            return
        })
        .catch(error => {
            setFetching(false)
            console.error(error);
            errorSetter('Error uploading image.');
        });
    };

    const handleFileChange = (event) => {
        const file = event.target.files[0];
        if (!file) {
            errorSetter('Kindly select an image file');
            return;
        }
        if (file.size > 2 * 1024 * 1024) {
          errorSetter('File size exceeds 2MB limit. Please select a smaller file.');
          return;
        }
    
        saveImageToFolder(file, event)
        return
    };

        
    const handleJobConnect = () => {
        if(hasDownloadedCv) {
            navigate('/user/dashboard/job-hub')
        } else {
            errorSetter("Download resume to proceed")
        }
    }
    

    const handleResumeSave = async () => {
        const completeResume = { ...resume, storageDetails }
        dispatch(setFetching(true));
        //set Resume for cover letter use
        dispatch(setResume(completeResume));
    
        try {
            const fileName = storageDetails.name + '.pdf';
            const blob = await pdf(selectTemplate()).toBlob();

            if(screenWidth < 1000) {
                // Mobile
                const blobUrl = URL.createObjectURL(blob);
                window.open(blobUrl, '_blank');
            } else {
                saveAs(blob, fileName);
            }

            // Track resume downloaded
            try { holisticAnalytics.track('resume.downloaded', { featureUsed: 'resume_builder' }); } catch(_) {}

            if(!hasDownloadedCv) {
                const response = await axios.post('/user/save-resume', completeResume, {
                    headers: {
                        'x-access-token': isAuth
                    }
                })
                ////run a CHECK HERE
                localStorage?.removeItem(
                    "5787378Tgigi879889%%%%7]][][]]]=-9-0d90900io90799CVBcvVVHGGYUYFUYIOUIUTY0I9T]---000789XZJHVB[[[27627787tdtu&3$*))(990-__)((@@"
                );

                // Clear cached career roadmap once the resume has been saved/downloaded
                try {
                    localStorage?.removeItem('careerRoadmapCache_v1');
                } catch (_) {}

                const successfulTargetAchievement = response?.data?.successfulTargetAchievement
                localStorage?.setItem("successfulTargetAchievement", successfulTargetAchievement)
    
                dispatch(setFetching(false));
                
                if(!hasDroppedFeedback) {
                    //to be used in jobhub
                    localStorage.setItem("feedbackTime", true)
                }
                setHasDownloadedCv(true)
            }

            successSetter("CV Downloaded Successfully")

        } catch (error) {
            dispatch(setFetching(false));
            errorSetter("Not saved to database, Try again")
        }

        dispatch(setFetching(false));
    }
    

    const handleDownload = () => {
        if(!canPrint) {
            return errorSetter('Select an AVAILABLE template to print')
        }
        
        if(!user?.resumeSubscriptions?.subscribed) {
            errorSetter('Please SUBSCRIBE to download resumes plus other BENEFITS')
            setIsSubscribed(false)
            return
        }
        if (!user.isFirstFreeUsed && resumeServicesNumbers?.resumeCreated >= 3) {
            errorSetter("You have reached the maximum number of free tier resumes. Please choose a plan to create more.");
            setIsSubscribed(false)
            return
        }
        if(storageDetails.name === "") {
            window.scrollTo(0, 0);
            return errorSetter('Resume must have a name')
        }
        if (resumeNameExist) {
            window.scrollTo(0, 0);
            return errorSetter('Resume name exists')
        }
        if (resumeSubDuration !== "Per Month" && resumeSubDuration !== "Per Week" && carouselName !== "Standard" && carouselName !== "Bubble Fish") {
            return errorSetter("Upgrade to Monthly or Weeekly for this template")
        }
        const note = screenWidth < 900 ? 'Click OK only when instruction completed. MOBILE DETECTED! Allow browser pop-ups when prompted to let CV download. RETURN BACK TO THIS TAB WHEN DONE FOR JOBS CONNECT' : 'This action is irreversible, continue?'
        confirm({ 
                description: note,
                title: "⚠️⚠️⚠️PLEASE READ⚠️⚠️⚠️"
            })
            .then(() => {
                handleResumeSave() 
            })
            .catch(() => {
                errorSetter("Resume not yet printed")
            });
    }

    const handleContextMenu = (event) => {
        event.preventDefault(); // Prevent the default right-click context menu
    };

    return (
        <div className="auth-container">
            {/* For SIDE MENU */}
            <AuthSideMenu
                opened={authMenuOpen}
                hidden={!authMenuOpen}
                resumeSubDuration={resumeSubDuration}
                isResumeSubbed={isSubscribed}
                arrayDetails={userResumesAll}
                firstName={user.firstName}
            />

            <BubbleFloat />

            <div className="auth-container-inner">
                {/* Top authenticated header with working hamburger */}
                <AuthHeader authMenuOpen={authMenuOpen} onClick={toggleResumes} headerText="Download Resume" />

                <DataContainerStyled theme={themeName} onClick={() => setAuthMenuOpen(false)}>
                    <DataHeader activeStep={3} />
                    <div className="dataContent">
                        <PageDataContainerStyled theme={themeName}>
                            <div style={{ width: '95%', margin: '0.5rem auto' }}>
                                {screenWidth < 900 && (
                                  <Alert sx={{ padding: '0 5px', fontSize: '.7rem' }} severity="info">
                                    MOBILE DETECTED: Allow browser pop-ups to allow CV download. If you do not, you will lose your download.
                                  </Alert>
                                )}
                                {resumeSubDuration !== "Per Week" && resumeSubDuration !== "Per Month" && (
                                  <Alert sx={{ padding: '0 5px', fontSize: '.7rem' }} severity="warning">
                                    Click Download only when you are sure to download as action is not reversible for non-premuim users
                                  </Alert>
                                )}
                            </div>

                            {/* Save Resume Details */}
                            <div style={{ width: '95%', margin: '0.5rem auto' }}>
                                <h2>Save Resume Details</h2>
                                <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
                                    <InputHandler
                                        id="resumeName"
                                        type="text"
                                        label="Resume Name"
                                        name="resumeName"
                                        value={storageDetails.name}
                                        onChange={handleInputChange('name')}
                                        required
                                        disabled={false}
                                        onBlur={() => checkObjectForKeyValue(user.resumes, "storageDetails", "name", storageDetails.name)}
                                    />
                                </div>
                            </div>

                            {/* Choose Template */}
                            <div style={{ width: '95%', margin: '0.5rem auto' }}>
                                <h2>Choose Template</h2>
                                <div className={resumeCss.TemplateContainer}>
                                    <Carousel
                                        responsive={responsive}
                                        swipeable
                                        draggable
                                        ssr
                                        infinite
                                        keyBoardControl
                                        customTransition="all .5 ease-in-out"
                                        transitionDuration={500}
                                        containerClass="carousel-container"
                                        dotListClass="custom-dot-list-style"
                                        itemClass="carousel-item-padding-40-px"
                                        centerMode={screenWidth > 900 ? false : true}
                                        focusOnSelect={screenWidth < 900}
                                    >
                                        {carouselData.map((item, index) => (
                                            <CarouselItem
                                                key={index}
                                                item={item}
                                                index={index}
                                                activeIndex={activeIndex}
                                                handleItemClick={handleItemClick}
                                            />
                                        ))}
                                    </Carousel>
                                </div>
                            </div>

                            {/* Upload Image (if applicable) */}
                            {hasImg && (
                                <div style={{ width: '95%', margin: '0.5rem auto' }}>
                                    <h2>Upload Image</h2>
                                    <div style={{ textAlign: 'center', fontSize: '.8rem' }}>
                                        <input style={{ marginLeft: '50px' }} type="file" accept="image/*" onChange={handleFileChange} />
                                    </div>
                                </div>
                            )}

                            {/* View and Download */}
                            <div style={{ width: '95%', margin: '0.5rem auto' }}>
                                <h2>View and Download</h2>
                                {screenWidth < 900 && (
                                    <div>
                                        <Alert sx={{ width: '100%', padding: '0 5px', display: 'flex', justifyContent: 'center', fontSize: '.7rem' }} severity="info">
                                            <div>Only first page is displayed on mobile. Download for complete view</div>
                                        </Alert>
                                        <Alert sx={{ width: '100%', padding: '0 5px', display: 'flex', justifyContent: 'center', fontSize: '.7rem' }} severity="info">
                                            <div>If not displayed on older Android versions, proceed to download after picking template.</div>
                                        </Alert>
                                    </div>
                                )}
                                {!isSubscribed && (
                                    <Alert sx={{ width: '100%', padding: '0 5px', display: 'flex', justifyContent: 'center', fontSize: '.7rem', marginTop: '10px' }} severity="info">
                                        <div><a href='/#pricing' className='link' onClick={(e) => { e.preventDefault(); setPricingOpen(true); }}>Upgrade Subscription Here</a> to enable resume scrolling</div>
                                    </Alert>
                                )}

                                <ProtectedContent>
                                    <div id="ComponentRef" ref={componentRef} className={resumeCss.ResponsivePrintView}>
                                        <PDFViewer style={styles.viewerContainer} showToolbar={false}>
                                            {selectTemplate()}
                                        </PDFViewer>
                                        {!isSubscribed && (
                                            <div
                                                onContextMenu={handleContextMenu}
                                                style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, zIndex: 1 }}
                                            />
                                        )}
                                    </div>
                                </ProtectedContent>

                                <div style={{ width: '100%', display: 'flex', justifyContent: 'center', marginBottom: '10px' }}>
                                    <div style={{ width: screenWidth < 500 ? '250px' : '350px' }}>
                                        <ButtonOutlineGreenWithDiffStyle type="button" onClick={handleDownload}>
                                            <DownloadForOfflineIcon fontSize='medium' /><span style={{ marginLeft: '5px', paddingTop: '1px' }}>Download Resume </span>
                                        </ButtonOutlineGreenWithDiffStyle>
                                    </div>
                                </div>

                                <div style={{ width: '100%', display: 'flex', justifyContent: 'center', marginBottom: '20px' }}>
                                    <div style={{ width: screenWidth <= 500 ? '250px' : '350px' }}>
                                        <ButtonSubmitGreen type="button" onClick={handleJobConnect}>
                                            <PiPlugsConnected style={{ color: '#F8E231', fontSize: '1.5rem' }} /><span style={{ marginLeft: '5px', paddingTop: '1px' }}>View Job Connect for this CV</span>
                                        </ButtonSubmitGreen>
                                    </div>
                                </div>
                            </div>
                        </PageDataContainerStyled>
                    </div>
                </DataContainerStyled>
            </div>

            {!isSubscribed && (
                <ResumePricing open={pricingOpen} closePricing={() => navigate('/user/dashboard/resume')} />
            )}
            

            {/* {completed &&  (                
                <SuccessFailureModal 
                    success={true} 
                    notApaymentTextPositive="Resume Creation Completed!"
                    notApayment={true}
                    resume={resume}
                    shareableLink={shareableLink}
                    aiSuggestedJobs={aiSuggestedJobs}
                    template={storageDetails.template}
                    imgUrl={imgUrl}
                />
            )} */}
                            
        </div>
    )
}


export default DownloadResume;